<div class="w-full h-screen flex px-15 xs:px-5 content">
  <!-- view mobile -->
  <div class="w-3/5 xl:w-4/6 xs:w-full text-center p-4 hidden xs:flex relative cover" *ngIf="showCover">
    <div class="w-full h-4/5 grid">
      <img class="m-auto w-3/5" src="assets/logo-edwallet.webp" alt="" />
      <img class="m-auto object-cover h-full" src="assets/bg-auth.png" alt="" />
    </div>
    <button mat-fab color="primary" class="right-0 bottom-0 m-10" aria-label="show cover" (click)="showCover = false">
      <mat-icon class="fa-regular fa-chevron-right"></mat-icon>
    </button>
  </div>

  <!-- view desktop -->
  <div class="w-1/2 xs:w-full bg-white text-center border-r-2 border-gray-300 p-8 flex xs:hidden relative items-center"
    *ngIf="showCover">
    <div class="w-full">
      <img class="m-auto w-2/5" src="assets/logo-edwallet.webp" alt="" />
      <div class="text-gray-400 mb-5">{{ 'auth:imgSubtitle' | translate }}</div>
      <img class="m-auto object-scale-down" [style.maxHeight.vh]="70" src="assets/bg-auth.png" alt="" />
    </div>
    <div class="w-12 h-12 rounded-full bg-white shadow-xl absolute right-0 -mr-6 flex justify-center items-center">
      <mat-icon class="fa-regular fa-chevron-right"></mat-icon>
    </div>
  </div>
  <div class="w-1/2 xs:w-full overflow-y-auto flex relative justify-center items-center">
    <div class="w-full">
      <div class="xs:p-5 sm:p-10 md:p-20 p-32 py-10">
        <img class="w-20 m-auto mb-5" src="assets/logo-edvisor.svg" alt="" />
        <h1 class="text-center">{{ 'auth:title' | translate }}</h1>
        <div class="text-center text-gray-400 mb-5 w-3/5 m-auto">
          {{ 'auth:subtitle' | translate }}
        </div>

        <treo-message
          class="mb-3"
          [appearance]="'outline'"
          [showIcon]="true"
          [showButtonClose]="false"
          [type]="'info'"
          *ngIf="userInactivity">
          <div treoMessageTitle>
            {{ 'auth:messageTitle' | translate }}
          </div>
          <div>{{ 'auth:messageSubtitle' | translate }}</div>
        </treo-message>

        <div class="flex flex-col h-full">
          <div class="border-custom-primary shadow-md mb-3 h-20" (click)="signIn()">
            <div class="flex flex-col w-10 h-10 justify-center items-center gt-xs:mr-4 mr-2">
              <mat-icon class="fa-regular fa-circle-user fz-2"></mat-icon>
            </div>
            <div class="flex-1 pl-1 mr-2 gt-xs:mr-16">
              <div class="font-medium text-black truncate-1">
                {{ 'auth:signIn' | translate }}
              </div>
              <div class="text-gray-600 text-sm">
                {{ 'auth:signInSubtitle' | translate }}
              </div>
            </div>
          </div>

          <div class="border-custom-primary shadow-md mb-3 h-20" (click)="signUp()">
            <div class="flex flex-col w-10 h-10 justify-center items-center gt-xs:mr-4 mr-2">
              <mat-icon class="fa-regular fa-thumbs-up fz-2"></mat-icon>
            </div>
            <div class="flex-1 pl-1 mr-2 gt-xs:mr-16">
              <div class="font-medium text-black truncate-1">
                {{ 'auth:signUp' | translate }}
              </div>
              <div class="text-gray-600 text-sm">
                {{ 'auth:signUpSubtitle' | translate }}
              </div>
            </div>
          </div>

          <div class="text-center m-auto">
            <!-- help -->
            <ew-button-help url="https://help.edvisor.io/edwallet/create-account"></ew-button-help>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>